/* ════════════════════════════════════════════════════════════════════════════
   device-kit.js — общие органы слоя «прибор» (partials/device-kit).

   Здесь только то, что одинаково у всех приборов и что иначе расползлось бы
   восемью копиями: шаговое поле, аккордеон инспектора, полноэкранный режим,
   плавающее окно поверх других окон, пиктограммы для разметки из скрипта и
   проверка Премиума. Логика самих приборов живёт в их файлах.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
    'use strict';
    if (window.DeviceKit) return;

    /* ⚠️ Копия набора из components/dk-icon.blade.php. Правишь путь там —
       правь здесь; расхождение ловит DeviceKitIconParityTest. */
    var ICONS = {
        'play': '<path d="M7.5 4.8v14.4a.8.8 0 0 0 1.2.7l11.1-7.2a.8.8 0 0 0 0-1.4L8.7 4.1a.8.8 0 0 0-1.2.7z" fill="currentColor" stroke="none"/>',
        'pause': '<rect x="6" y="4.5" width="4" height="15" rx="1.2" fill="currentColor" stroke="none"/><rect x="14" y="4.5" width="4" height="15" rx="1.2" fill="currentColor" stroke="none"/>',
        'stop': '<rect x="5.5" y="5.5" width="13" height="13" rx="2.5" fill="currentColor" stroke="none"/>',
        'reset': '<path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1L3.5 8.5"/><path d="M3.5 3.5v5h5"/>',
        'flag': '<path d="M5 21V4"/><path d="M5 4h12l-2.5 4.5L17 13H5"/>',
        'check': '<path d="M20 6 9 17l-5-5"/>',
        'save': '<path d="M5 3h11l3 3v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"/><path d="M8 3v5h7V3M8 21v-7h8v7"/>',
        'expand': '<path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/>',
        'keyboard': '<rect x="2" y="6" width="20" height="12" rx="2.5"/><path d="M6.5 10h.01M10 10h.01M13.5 10h.01M17.5 10h.01M7.5 14h9"/>',
        'download': '<path d="M12 3.5v11.5m0 0-4.5-4.5M12 15l4.5-4.5M5 20.5h14"/>',
        'upload': '<path d="M12 20.5V9m0 0-4.5 4.5M12 9l4.5 4.5M5 3.5h14"/>',
        'users': '<path d="M16 20v-1.5A3.5 3.5 0 0 0 12.5 15h-6A3.5 3.5 0 0 0 3 18.5V20"/><circle cx="9.5" cy="8" r="3.5"/><path d="M21 20v-1.5a3.5 3.5 0 0 0-2.6-3.4M15.5 4.7a3.5 3.5 0 0 1 0 6.6"/>',
        'volume': '<path d="M11 5 6.5 9H3v6h3.5L11 19z"/><path d="M15.5 9a4.5 4.5 0 0 1 0 6M18.5 6a8.5 8.5 0 0 1 0 12"/>',
        'bell': '<path d="M6 9a6 6 0 0 1 12 0c0 6.5 2.5 8.5 2.5 8.5h-17S6 15.5 6 9"/><path d="M10.3 21a2 2 0 0 0 3.4 0"/>',
        'sliders': '<path d="M4 20v-6M4 10V4M12 20v-8M12 8V4M20 20v-4M20 12V4M2 14h4M10 8h4M18 16h4"/>',
        'info': '<circle cx="12" cy="12" r="9.5"/><path d="M12 16.5v-5M12 8h.01"/>',
        'plus': '<path d="M12 5v14M5 12h14"/>',
        'minus': '<path d="M5 12h14"/>',
        'x': '<path d="M18 6 6 18M6 6l12 12"/>',
        'undo': '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>',
        'share': '<path d="M12 3.5v12M7.5 8 12 3.5 16.5 8"/><path d="M5 12.5V19a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6.5"/>',
        'qr': '<rect x="3.5" y="3.5" width="6.5" height="6.5" rx="1"/><rect x="14" y="3.5" width="6.5" height="6.5" rx="1"/><rect x="3.5" y="14" width="6.5" height="6.5" rx="1"/><path d="M14 14h2.5v2.5H14zM20.5 14v.01M14 20.5h.01M18 18h2.5v2.5"/>',
        'timer': '<circle cx="12" cy="13.5" r="7.5"/><path d="M12 9.5v4l2.5 2M9.5 2.5h5"/>',
        'clock': '<circle cx="12" cy="12" r="9.5"/><path d="M12 6.5V12l3.5 2"/>',
        'trophy': '<path d="M8 21h8M12 16.5V21M7 4h10v5a5 5 0 0 1-10 0z"/><path d="M17 5.5h2.5v1.5a3 3 0 0 1-3 3M7 5.5H4.5V7a3 3 0 0 0 3 3"/>',
        'camera': '<path d="M14.5 4.5h-5L7.5 7H4.5a2 2 0 0 0-2 2v8.5a2 2 0 0 0 2 2h15a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"/><circle cx="12" cy="13" r="3.5"/>',
        'video': '<rect x="2.5" y="6" width="13" height="12" rx="2"/><path d="m15.5 10.5 6-3.5v10l-6-3.5"/>',
        'file': '<path d="M14 2.5H6.5a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8z"/><path d="M14 2.5V8h5.5M8.5 13h7M8.5 17h4.5"/>',
        'table': '<rect x="3" y="3.5" width="18" height="17" rx="2"/><path d="M3 9.5h18M3 15h18M9.5 3.5v17"/>',
        'shuffle': '<path d="M16 3.5h4.5V8M4 20 20.5 3.5M20.5 16v4.5H16M15 15l5.5 5.5M4 4l5 5"/>',
        'printer': '<path d="M6.5 9V3h11v6"/><rect x="6.5" y="14" width="11" height="7" rx="1"/><path d="M6.5 18H4.5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>',
        'folder': '<path d="M3 7.5a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2V10H3z"/><path d="M3 10h18l-1.8 8.4a2 2 0 0 1-2 1.6H6.8a2 2 0 0 1-2-1.6z"/>',
        'megaphone': '<path d="M3.5 10.5 19 5.5v13l-15.5-5z"/><path d="M11.5 16.2a3 3 0 1 1-5.8-1.5"/>',
        'whistle': '<circle cx="9" cy="13.5" r="5.5"/><path d="M13.5 10.5h6a1.5 1.5 0 0 1 1.5 1.5v1a3 3 0 0 1-3 3h-1.5M9 13.5h.01M4.5 6.5l2 2"/>',
        'swap': '<path d="M16 3.5 20 7.5l-4 4M20 7.5H4M8 20.5l-4-4 4-4M4 16.5h16"/>',
        'left': '<path d="m15 18-6-6 6-6"/>',
        'right': '<path d="m9 18 6-6-6-6"/>',
        'monitor': '<rect x="2.5" y="3.5" width="19" height="13" rx="2"/><path d="M8 20.5h8M12 16.5v4"/>',
        'pip': '<rect x="2.5" y="4.5" width="19" height="15" rx="2"/><rect x="12" y="11.5" width="7" height="5.5" rx="1" fill="currentColor" stroke="none"/>',
        'mic': '<rect x="9" y="2.5" width="6" height="11.5" rx="3"/><path d="M5.5 10.5a6.5 6.5 0 0 0 13 0M12 17v4.5"/>',
        'star': '<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9z"/>',
        'calendar': '<rect x="3" y="4.5" width="18" height="17" rx="2"/><path d="M16 2.5v4M8 2.5v4M3 10h18"/>',
        'link': '<path d="M10 13.5a4.5 4.5 0 0 0 6.8.5l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.5 1.5"/><path d="M14 10.5a4.5 4.5 0 0 0-6.8-.5l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.5-1.5"/>',
        'eye': '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
        'activity': '<path d="M21.5 12h-4l-3 8.5-5-17-3 8.5h-4"/>',
        'list': '<path d="M8.5 6h12M8.5 12h12M8.5 18h12M3.5 6h.01M3.5 12h.01M3.5 18h.01"/>',
        'grid': '<rect x="3.5" y="3.5" width="7" height="7" rx="1.2"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.2"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.2"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.2"/>',
        'trash': '<path d="M3.5 6.5h17M9 6.5V4.5h6v2M18.5 6.5l-.9 13a2 2 0 0 1-2 1.9H8.4a2 2 0 0 1-2-1.9l-.9-13"/>',
        'edit': '<path d="M16.5 3.5a2.5 2.5 0 0 1 3.5 3.5L7.5 19.5 3 21l1.5-4.5z"/>',
        'copy': '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4.5a2 2 0 0 1-2-2V4.5a2 2 0 0 1 2-2H13a2 2 0 0 1 2 2V5"/>',
        'lock': '<rect x="4" y="10.5" width="16" height="11" rx="2"/><path d="M7.5 10.5V7a4.5 4.5 0 0 1 9 0v3.5"/>',
        'target': '<circle cx="12" cy="12" r="9.5"/><circle cx="12" cy="12" r="5.5"/><circle cx="12" cy="12" r="1.5"/>',
        'zap': '<path d="M13 2.5 4.5 13.5H12l-1 8 8.5-11H12z"/>',
        'wifi': '<path d="M2 8.5a15 15 0 0 1 20 0M5 12a10.5 10.5 0 0 1 14 0M8.5 15.5a5.5 5.5 0 0 1 7 0M12 19h.01"/>',
        'sun': '<circle cx="12" cy="12" r="4"/><path d="M12 2.5v2M12 19.5v2M4.6 4.6 6 6M18 18l1.4 1.4M2.5 12h2M19.5 12h2M4.6 19.4 6 18M18 6l1.4-1.4"/>',
        'layers': '<path d="m12 2.5 9.5 5-9.5 5-9.5-5z"/><path d="m2.5 12 9.5 5 9.5-5M2.5 16.5l9.5 5 9.5-5"/>',
        'hash': '<path d="M4.5 9h15M4.5 15h15M10 3.5 8 20.5M16 3.5l-2 17"/>',
        'music': '<path d="M9 18V5.5l11-2V16"/><circle cx="6.5" cy="18" r="2.5"/><circle cx="17.5" cy="16" r="2.5"/>',
        'moon': '<path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 0 0 11 11z"/>',
        'more': '<circle cx="5" cy="12" r="1.6" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none"/><circle cx="19" cy="12" r="1.6" fill="currentColor" stroke="none"/>',
        'cloud': '<path d="M7 18.5a4.5 4.5 0 0 1-.6-8.96 6 6 0 0 1 11.55-.9A4.5 4.5 0 0 1 17.5 18.5z"/>',
        'image': '<rect x="3" y="4.5" width="18" height="15" rx="2.5"/><circle cx="8.5" cy="9.5" r="1.8"/><path d="m21 16-5-5-9 8.5"/>',
        'palette': '<path d="M12 3a9 9 0 1 0 0 18c1.4 0 2-1 2-2 0-.6-.3-1-.6-1.4-.3-.4-.6-.8-.6-1.4 0-1.1.9-2 2-2h2.2A5 5 0 0 0 21 9.3C21 5.8 17 3 12 3z"/><circle cx="7.5" cy="11.5" r="1.2" fill="currentColor" stroke="none"/><circle cx="10" cy="7.5" r="1.2" fill="currentColor" stroke="none"/><circle cx="15" cy="7.5" r="1.2" fill="currentColor" stroke="none"/>',
        'class': 'dk-i'
    };

    function icon(name, cls) {
        return '<svg class="dk-i' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
            'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
            (ICONS[name] || '<rect x="4" y="4" width="16" height="16" rx="2"/>') + '</svg>';
    }

    /* ── шаговое поле ────────────────────────────────────────────────────────
       <div class="dk-step"><button data-step="-1">…</button><input type=number>
       <button data-step="1">…</button></div>. Кнопка шлёт input+change, как
       будто человек ввёл число сам: обработчики тула не знают о кнопках. */
    function steppers(root) {
        (root || document).querySelectorAll('.dk-step').forEach(function (box) {
            if (box.__dk) return;
            box.__dk = true;
            var input = box.querySelector('input');
            if (!input) return;
            box.querySelectorAll('button[data-step]').forEach(function (b) {
                b.addEventListener('click', function () {
                    if (input.disabled) return;
                    var step = parseFloat(b.getAttribute('data-step')) || 1;
                    var min = input.min !== '' ? parseFloat(input.min) : -Infinity;
                    var max = input.max !== '' ? parseFloat(input.max) : Infinity;
                    var cur = parseFloat(String(input.value).replace(',', '.'));
                    if (!isFinite(cur)) cur = isFinite(min) ? min : 0;
                    var next = Math.min(max, Math.max(min, Math.round((cur + step) * 1000) / 1000));
                    if (next === cur) return;
                    input.value = String(next);
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                });
            });
        });
    }

    /* ── аккордеон инспектора ────────────────────────────────────────────────
       Раздел — <section class="dk-sec" data-sec="…"> с кнопкой .dk-sec-h и
       телом .dk-sec-b; открыт тот, у кого .is-open. Открыт один раздел.
       На узком контейнере (одна колонка) все разделы свёрнуты при загрузке:
       прибор — сверху, настройки — строками со значениями. На широком открыт
       раздел, который человек открывал последним. */
    function setSecOpen(sec, on) {
        if (!sec) return;
        sec.classList.toggle('is-open', !!on);
        var h = sec.querySelector('.dk-sec-h');
        if (h) h.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function openSection(sec) {
        if (!sec) return;
        var side = sec.closest('.dk-inspector') || sec.parentNode;
        Array.prototype.forEach.call(side.querySelectorAll('.dk-sec'), function (s) { setSecOpen(s, s === sec); });
    }
    function accordion(side, opts) {
        if (!side) return;
        opts = opts || {};
        var secs = Array.prototype.slice.call(side.querySelectorAll('.dk-sec'));
        if (!secs.length) return;
        var slug = opts.slug || '', key = 'dk_open';
        var bp = opts.breakpoint || 860;
        var host = side.closest('.tc') || document.body;
        var remembered = '';
        try { if (slug && window.__toolSettings) remembered = window.__toolSettings.load(slug, key, '') || ''; } catch (e) { }
        var markupOpen = secs.filter(function (s) { return s.classList.contains('is-open'); })[0] || null;
        var touched = false;

        secs.forEach(function (s) {
            var h = s.querySelector('.dk-sec-h');
            var b = s.querySelector('.dk-sec-b');
            if (h && b) {
                if (!b.id) b.id = (s.getAttribute('data-sec') || 'sec') + '-' + Math.random().toString(36).slice(2, 7);
                h.setAttribute('aria-controls', b.id);
            }
            setSecOpen(s, s.classList.contains('is-open'));
        });
        /* Раскладка по умолчанию для ширины: узко — всё свёрнуто, широко —
           последний открытый человеком раздел или тот, что открыт в разметке. */
        function applyDefault(narrow) {
            if (narrow) { secs.forEach(function (s) { setSecOpen(s, false); }); return; }
            var hit = remembered && secs.filter(function (s) { return s.getAttribute('data-sec') === remembered; })[0];
            if (hit || markupOpen) openSection(hit || markupOpen);
        }
        var narrow = host.getBoundingClientRect().width < bp;
        applyDefault(narrow);
        secs.forEach(function (s) {
            var h = s.querySelector('.dk-sec-h');
            if (!h) return;
            h.addEventListener('click', function () {
                touched = true;
                if (s.classList.contains('is-open')) { setSecOpen(s, false); return; }
                openSection(s);
                remembered = s.getAttribute('data-sec') || '';
                try { if (slug && window.__toolSettings) window.__toolSettings.save(slug, key, remembered); } catch (e) { }
            });
        });
        /* Ширина контейнера может смениться ПОСЛЕ старта: сайдбар дорисовался,
           окно повернули, панель браузера открылась. Пока человек не трогал
           разделы, раскладка следует за шириной; тронул — его выбор главнее. */
        if (window.ResizeObserver) {
            var lastW = host.getBoundingClientRect().width;
            new ResizeObserver(function () {
                var w = host.getBoundingClientRect().width;
                if (Math.abs(w - lastW) < 1) return;
                lastW = w;
                var n = w < bp;
                if (n === narrow) return;
                narrow = n;
                if (!touched) applyDefault(narrow);
            }).observe(host);
        }
    }

    /* ── док: подписи уходят, когда им не хватает места ─────────────────────
       Длина подписей зависит от локали («Позвонить сейчас» против «Jetzt
       läuten»), поэтому порог ширины в CSS угадывал бы за одну локаль. Док
       сам меряет, помещается ли он в строку, и выбирает ступень:
         full  — все подписи;
         icons — вторичные кнопки только с пиктограммой, главная растягивается;
         min   — у главной уходит и пиктограмма, отступы плотнее.
       Замер идёт в нейтральном состоянии (без растяжения и переноса), всё в
       одном кадре — мигания нет. */
    function fitDock(dock) {
        if (!dock || dock.__dkFit) return;
        dock.__dkFit = true;
        var raf = 0;
        function need() {
            var cs = getComputedStyle(dock);
            var gap = parseFloat(cs.columnGap);
            if (!isFinite(gap)) gap = 8;
            var sum = 0, n = 0;
            Array.prototype.forEach.call(dock.children, function (el) {
                if (el.hidden || el.classList.contains('dk-dock-sep')) return;
                var w = el.getBoundingClientRect().width;
                if (!w) return;
                sum += w; n++;
            });
            var avail = dock.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
            return { sum: sum + Math.max(0, n - 1) * gap, avail: avail };
        }
        function apply() {
            raf = 0;
            if (!dock.isConnected || !dock.clientWidth) return;
            var levels = ['full', 'icons', 'min'];
            var chosen = 'min';
            dock.classList.add('dk-measuring');
            for (var i = 0; i < levels.length; i++) {
                dock.setAttribute('data-fit', levels[i]);
                var m = need();
                if (m.sum <= m.avail + 0.5) { chosen = levels[i]; break; }
            }
            dock.classList.remove('dk-measuring');
            if (dock.getAttribute('data-fit') !== chosen) dock.setAttribute('data-fit', chosen);
        }
        function schedule() { if (!raf) raf = requestAnimationFrame(apply); }
        apply();
        if (window.ResizeObserver) {
            var lastW = dock.clientWidth;
            new ResizeObserver(function () {
                if (Math.abs(dock.clientWidth - lastW) < 1) return;
                lastW = dock.clientWidth;
                schedule();
            }).observe(dock);
        } else {
            window.addEventListener('resize', schedule);
        }
        /* Подпись поменялась («Включить» → «Выключить»), кнопка показалась
           или спряталась — перемерить. Свой data-fit сюда не попадает: следим
           только за текстом и атрибутом hidden. */
        if (window.MutationObserver) {
            new MutationObserver(schedule).observe(dock, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
        }
        try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule); } catch (e) { }
    }

    /* Текст в свёрнутом заголовке раздела: «6 дорожек · 1 круг». */
    function summary(id, text) {
        var el = typeof id === 'string' ? document.getElementById(id) : id;
        if (el && el.textContent !== text) el.textContent = text;
    }

    /* ── полноэкранный режим ─────────────────────────────────────────────────
       webkit-префикс — iPad Safari до 16.4. На iPhone Fullscreen API для
       произвольного элемента нет вовсе: там отказ не бросаем, а честно
       говорим, что сделать (добавить на экран «Домой» / повернуть). */
    function fsElement() { return document.fullscreenElement || document.webkitFullscreenElement || null; }
    function toggleFullscreen(el, onUnsupported) {
        if (fsElement()) {
            (document.exitFullscreen || document.webkitExitFullscreen || function () { }).call(document);
            return true;
        }
        var req = el.requestFullscreen || el.webkitRequestFullscreen;
        if (!req) { if (onUnsupported) onUnsupported(); return false; }
        try {
            var p = req.call(el, { navigationUI: 'hide' });
            if (p && p.catch) p.catch(function () { if (onUnsupported) onUnsupported(); });
        } catch (e) { if (onUnsupported) onUnsupported(); return false; }
        return true;
    }
    function onFullscreenChange(cb) {
        document.addEventListener('fullscreenchange', cb);
        document.addEventListener('webkitfullscreenchange', cb);
    }

    /* ── Премиум ─────────────────────────────────────────────────────────────
       Снимок тарифа приезжает с session-bootstrap; гостю — анонимный. */
    function isPro() {
        try { if (window.__tierLimits && typeof window.__tierLimits.is_pro === 'boolean') return window.__tierLimits.is_pro; } catch (e) { }
        try { return !!(document.body && document.body.dataset && document.body.dataset.pro === '1'); } catch (e) { }
        return false;
    }
    function onTier(cb) {
        document.addEventListener('tier-bootstrap:ready', function () { try { cb(isPro()); } catch (e) { } });
        try { cb(isPro()); } catch (e) { }
    }

    /* ── Document Picture-in-Picture ─────────────────────────────────────────
       Окно поверх всех окон (Chrome/Edge 116+). В нём живёт ТОТ ЖЕ узел
       страницы — не копия, поэтому обработчики и состояние остаются одни.
       ⚠️ Но узел уезжает в ДРУГОЙ документ: document.getElementById его и всё
       внутри больше не находит, пока окно открыто. Узлы переносимого — только
       ссылками, взятыми до переноса (school-bell: тик падал на первой секунде
       мини-окна, Sentry PG; tinnitus-notch — то же в renderMini).
       Возвращает null там, где API нет: кнопку тогда не показываем вовсе. */
    function pipSupported() { return !!(window.documentPictureInPicture && window.documentPictureInPicture.requestWindow); }
    function openPip(node, opts) {
        if (!pipSupported() || !node) return Promise.resolve(null);
        opts = opts || {};
        var placeholder = document.createComment('dk-pip');
        return window.documentPictureInPicture.requestWindow({
            width: opts.width || 420, height: opts.height || 260,
            disallowReturnToOpener: false, preferInitialWindowPlacement: false
        }).then(function (pw) {
            /* Стили страницы — ссылками и копиями <style>: у окна свой документ. */
            Array.prototype.forEach.call(document.querySelectorAll('link[rel=stylesheet],style'), function (s) {
                try { pw.document.head.appendChild(s.cloneNode(true)); } catch (e) { }
            });
            var theme = document.documentElement.getAttribute('data-theme');
            if (theme) pw.document.documentElement.setAttribute('data-theme', theme);
            pw.document.body.className = 'dk-pip-body ' + (opts.bodyClass || '');
            var wrap = pw.document.createElement('div');
            wrap.className = (opts.wrapClass || '') + ' dk-pip-wrap';
            pw.document.body.appendChild(wrap);
            node.parentNode.insertBefore(placeholder, node);
            wrap.appendChild(node);
            if (opts.onOpen) { try { opts.onOpen(pw); } catch (e) { } }
            pw.addEventListener('pagehide', function () {
                if (placeholder.parentNode) placeholder.parentNode.insertBefore(node, placeholder);
                placeholder.remove();
                if (opts.onClose) { try { opts.onClose(); } catch (e) { } }
            });
            return pw;
        }).catch(function () { return null; });
    }

    /* ── QR-код ──────────────────────────────────────────────────────────────
       На страницах лежит qrcode-generator (глобальная `qrcode`), у которой нет
       конструктора `QRCode(el, …)`: вызовы вида `new QRCode(...)` молча не
       рисовали ничего — так жили пульт табло и ссылка школьного звонка.
       Рисуем модули сами, с тихой зоной в три модуля. Вернёт false, если
       библиотеки нет (её грузят defer) — вызывающий может повторить позже. */
    function qr(host, text, size) {
        if (!host) return false;
        host.textContent = '';
        var gen = window.qrcode;
        if (typeof gen !== 'function' || !text) return false;
        try {
            var q = gen(0, 'M');
            q.addData(String(text));
            q.make();
            var n = q.getModuleCount(), quiet = 3;
            var cell = Math.max(2, Math.floor((size || 176) / (n + quiet * 2)));
            var px = cell * (n + quiet * 2);
            var c = document.createElement('canvas');
            c.width = px; c.height = px;
            c.style.width = px + 'px'; c.style.height = px + 'px';
            var g = c.getContext('2d');
            g.fillStyle = '#fff'; g.fillRect(0, 0, px, px);
            g.fillStyle = '#000';
            for (var r = 0; r < n; r++) for (var k = 0; k < n; k++) if (q.isDark(r, k)) g.fillRect((k + quiet) * cell, (r + quiet) * cell, cell, cell);
            c.setAttribute('role', 'img');
            host.appendChild(c);
            return true;
        } catch (e) { return false; }
    }

    /* Безопасный вызов телеметрии: у приборов нет права падать из-за неё. */
    function track(stage, data) { try { if (window.__aeFunnel) window.__aeFunnel(stage, data || {}); } catch (e) { } }

    window.DeviceKit = {
        icon: icon,
        steppers: steppers,
        accordion: accordion,
        openSection: openSection,
        fitDock: fitDock,
        summary: summary,
        toggleFullscreen: toggleFullscreen,
        fullscreenElement: fsElement,
        onFullscreenChange: onFullscreenChange,
        isPro: isPro,
        onTier: onTier,
        pipSupported: pipSupported,
        openPip: openPip,
        qr: qr,
        track: track
    };
})();
